
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class SalesCommissionViewModel extends Model<SalesCommissionViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'orderId', type: 'string' },
		{ name: 'referenceNumber', type: 'number' },
		{ name: 'orderLineId', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'sellerId', type: 'string' },
		{ name: 'salesTeamId', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'signDate', type: 'Date' },
		{ name: 'withholdCommission', type: 'boolean' },
		{ name: 'companyHadActivePlans', type: 'boolean' },
		{ name: 'approved', type: 'number' },
		{ name: 'productVariantId', type: 'string' },
		{ name: 'productName', type: 'string' },
		{ name: 'variantName', type: 'string' },
		{ name: 'quantity', type: 'number' },
		{ name: 'unitPrice', type: 'number' },
		{ name: 'totalPrice', type: 'number' },
		{ name: 'startupAmount', type: 'number' },
		{ name: 'startupInstallments', type: 'number' },
		{ name: 'paymentInterval', type: 'number' },
		{ name: 'period', type: 'number' },
		{ name: 'orderCancelled', type: 'number' },
		{ name: 'orderWarning', type: 'number' },
		{ name: 'cancelledStatus', type: 'string' },
		{ name: 'acvExtend', type: 'number' },
		{ name: 'acvIncrease', type: 'number' },
		{ name: 'upFront', type: 'number' },
		{ name: 'oneOffAmount', type: 'number' },
		{ name: 'accumulatedSalesValue', type: 'number' },
		{ name: 'acvExtendCommissionEnabled', type: 'boolean' },
		{ name: 'acvIncreaseCommissionEnabled', type: 'boolean' },
		{ name: 'upFrontCommissionEnabled', type: 'boolean' },
		{ name: 'oneOffCommissionEnabled', type: 'boolean' },
		{ name: 'accumulatedCommissionValue', type: 'number' },
		{ name: 'discount', type: 'number' }
	];
	[key: string]: any;
	
	public orderId?: string;
	public referenceNumber: number;
	public orderLineId?: string;
	public companyId?: string;
	public sellerId?: string;
	public salesTeamId?: string;
	public created?: Date;
	public signDate?: Date;
	public withholdCommission: boolean;
	public companyHadActivePlans: boolean;
	public approved: number;
	public productVariantId?: string;
	public productName: string;
	public variantName: string;
	public quantity: number;
	public unitPrice?: number;
	public totalPrice: number;
	public startupAmount?: number;
	public startupInstallments?: number;
	public paymentInterval: number;
	public period: number;
	public orderCancelled: number;
	public orderWarning: number;
	public cancelledStatus: string;
	public acvExtend: number;
	public acvIncrease: number;
	public upFront: number;
	public oneOffAmount: number;
	public accumulatedSalesValue?: number;
	public acvExtendCommissionEnabled: boolean;
	public acvIncreaseCommissionEnabled: boolean;
	public upFrontCommissionEnabled: boolean;
	public oneOffCommissionEnabled: boolean;
	public accumulatedCommissionValue?: number;
	public discount?: number;
    
	constructor(){
		super();
		this.orderId = undefined;
		this.referenceNumber = 0;
		this.orderLineId = undefined;
		this.companyId = undefined;
		this.sellerId = undefined;
		this.salesTeamId = undefined;
		this.created = undefined;
		this.signDate = undefined;
		this.withholdCommission = false;
		this.companyHadActivePlans = false;
		this.approved = 0;
		this.productVariantId = undefined;
		this.productName = '';
		this.variantName = '';
		this.quantity = 0;
		this.unitPrice = undefined;
		this.totalPrice = 0;
		this.startupAmount = undefined;
		this.startupInstallments = undefined;
		this.paymentInterval = 0;
		this.period = 0;
		this.orderCancelled = 0;
		this.orderWarning = 0;
		this.cancelledStatus = '';
		this.acvExtend = 0;
		this.acvIncrease = 0;
		this.upFront = 0;
		this.oneOffAmount = 0;
		this.accumulatedSalesValue = undefined;
		this.acvExtendCommissionEnabled = false;
		this.acvIncreaseCommissionEnabled = false;
		this.upFrontCommissionEnabled = false;
		this.oneOffCommissionEnabled = false;
		this.accumulatedCommissionValue = undefined;
		this.discount = undefined;
		
	}
	getProperties(){
		return SalesCommissionViewModel.classProperties;
	}
}

